import styled from 'styled-components';

const O2Logo = styled.section`
  > img {
    width: 10rem;
  }
`;

export default O2Logo;
